import { render, staticRenderFns } from "./BindPhone.vue?vue&type=template&id=7e5de0fe&scoped=true&"
import script from "./BindPhone.vue?vue&type=script&lang=js&"
export * from "./BindPhone.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e5de0fe",
  null
  
)

export default component.exports